<script>
  import { onMount } from 'svelte';
  import { InlineNotification, Toggle } from 'carbon-components-svelte';

  import LoadingSpinner from '../../components/LoadingSpinner.svelte';

  import { getFlags, updateFlag } from '../../services';
  import { getServerErrorMessage } from '../../utils';
  import { DB_FLAGS } from '../../../shared/constants';

  let pageData = { loading: true };
  let flags = [];

  function handleToggleEvent(key) {
    return async function onToggle({ detail: { toggled } }) {
      const flagToChange = flags.find((flag) => flag.id === key);
      if (flagToChange.status === toggled) {
        return;
      }

      try {
        pageData = { loading: true, errorMessage: null };
        await updateFlag(key, { status: toggled });
        flags = flags.map((flag) => (flag.id === key ? { ...flag, status: toggled } : flag));
        pageData = { loading: false };
      } catch (error) {
        const errorMessage = getServerErrorMessage(error) ?? 'Could not fetch flags!';
        console.error('[Flags] Failed to fetch flags!', errorMessage);
        pageData = { ...pageData, errorMessage: errorMessage ?? 'Failed to update flag', loading: false };
      }
    };
  }

  async function fetchFlags() {
    try {
      flags = await getFlags();
      pageData = { loading: false };
    } catch (error) {
      const errorMessage = getServerErrorMessage(error) ?? 'Could not fetch flags!';
      console.error('[Flags] Failed to fetch flags!', errorMessage);
      pageData = { ...pageData, errorMessage: `Failed to fetch flags! ${errorMessage}`, loading: false };
    }
  }

  onMount(fetchFlags);

  $: flags = Object.values(DB_FLAGS).reduce((all, flag) => {
    const flagIsLive = flags.find((f) => f.id === flag);
    if (!flagIsLive) {
      return [...all, { id: flag, status: false }];
    }
    return all;
  }, flags);
</script>

{#if pageData.errorMessage}
  <InlineNotification hideCloseButton kind="error" lowContrast title="Error:" subtitle={pageData.errorMessage} />
{/if}
<LoadingSpinner loading={pageData.loading}>
  <div class="flags-container">
    {#each flags as flag}
      <div class="flag">
        <Toggle id={flag.id} labelText={flag.id} toggled={flag.status} on:toggle={handleToggleEvent(flag.id)} />
      </div>
    {/each}
  </div>
</LoadingSpinner>

<style>
  .flag {
    margin-bottom: 1rem;
  }

  .flags-container :global(.bx--toggle__switch) {
    margin-top: 0.25rem;
  }
</style>
